import { useState } from "react";
import { Phone, MessageCircle, MapPin, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { company } from "@/config/content";
import { useLang } from "@/i18n/LanguageContext";
import { openWhatsApp, emergencyMessage, sendLocationToWhatsApp } from "@/lib/whatsapp";

// Fixed bottom emergency bar for mobile. Three 48px+ touch targets, safe-area aware.
export function MobileEmergencyBar() {
  const { t, lang } = useLang();
  const [loading, setLoading] = useState(false);

  const onLocation = () => {
    sendLocationToWhatsApp({
      lang,
      onStart: () => setLoading(true),
      onError: (msg) => {
        setLoading(false);
        toast.error(msg, { duration: 7000 });
      },
    });
    setTimeout(() => setLoading(false), 12000);
  };

  return (
    <div
      data-testid="mobile-emergency-bar"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-edge bg-asphalt/95 backdrop-blur-md safe-bottom lg:hidden"
    >
      <div className="grid grid-cols-3">
        <a
          href={company.phoneHref}
          data-testid="bar-call-btn"
          className="flex min-h-[60px] flex-col items-center justify-center gap-1 border-r border-edge py-2 text-carbon"
          style={{ background: "#F6B800" }}
        >
          <Phone className="h-5 w-5" strokeWidth={2.4} />
          <span className="text-[11px] font-bold uppercase tracking-wide">{t.common.call}</span>
        </a>
        <button
          type="button"
          data-testid="bar-whatsapp-btn"
          onClick={() => {
            toast(t.whatsappNotice);
            openWhatsApp(emergencyMessage(lang));
          }}
          className="flex min-h-[60px] flex-col items-center justify-center gap-1 border-r border-edge py-2 text-ice"
        >
          <MessageCircle className="h-5 w-5 text-whatsapp" strokeWidth={2.4} />
          <span className="text-[11px] font-bold uppercase tracking-wide">{t.common.whatsappShort}</span>
        </button>
        <button
          type="button"
          data-testid="bar-location-btn"
          onClick={onLocation}
          disabled={loading}
          className="flex min-h-[60px] flex-col items-center justify-center gap-1 py-2 text-ice disabled:opacity-70"
        >
          {loading ? <Loader2 className="h-5 w-5 animate-spin text-signal" /> : <MapPin className="h-5 w-5 text-signal" strokeWidth={2.4} />}
          <span className="text-[11px] font-bold uppercase tracking-wide">{t.common.location}</span>
        </button>
      </div>
    </div>
  );
}
